import styled, { spacing } from "@rentiohq/web-theme";

export const Wrap = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: ${spacing("loose")};
`;

export const Row = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: inherit;
`;

export const RoleCell = styled.div`
  flex: 10;
`;

export const HeaderCell = styled.div`
  flex: 8;
  text-align: center;
  padding: 0 1px;
`;

export const Cell = styled.div`
  flex: 8;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
